import { useState, useRef } from 'react';
import {ReactComponent as Logo} from '../../assets/images/ugcan-logo.svg';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@material-tailwind/react';
import { useLocation } from 'react-router-dom';


export default function ResendActivationLink(props) {
  const [form, setForm] = useState({ email: ''});
    const navigate = useNavigate();
    const { state } = useLocation();
    const [message, setMessage] = useState(state?.param_message);
    const status = useRef(0);
    const [error,setError] = useState('');
    const buttonClass = `m-2 p-2 h-auto w-fit 
                  bg-transparent text-primary-900 hover:text-white hover:bg-primary-900 
                  border-2 rounded-lg 
                  text-base font-bold tracking-widest normal-case items-center`;
    console.log('in resend activation')
    const fieldClass = "w-full bg-tertiary-600 m-1 p-2 text-sm font-nunito placeholder:text-gray-500 rounded"
    const handleChange = (e) => {
      setForm({ ...form, [e.target.name]: e.target.value });
    };
    
    const handleSubmit = async (e) => {
      e.preventDefault();
      // Simple email format check (optional)
      const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email);
      console.log(form.email)
      if (!form.email) {
        setError("Email is required.");
        return;
      }
    
      if (!isEmailValid) {
        setError("Please enter a valid email address.");
        return;
      }
      try {
        await axios.post('/auth/users/resend_activation/', { email: form.email });
        setMessage('If the email is valid, you’ll receive a message.');
        status.current = 1
      } catch (err) {
        console.log(err)
        if (err.response && err.response?.data) {
          const error = err.response?.data?.detail;
          if (error === "User is already activated.") {
            setMessage("Your account is already active. Please log in.");
          } else {
            setMessage("Something went wrong. Try again later.");
          }
          setError(`Response error: ${err.response.data}, Status code: ${err.response.status}`); 
        } else if (err.request) {
          // Request was made, but no response was received
          setError( `Request error: ${err.request}`); // The request made, containing data and headers
        } else {
          setError(`${err.message} - ${err.message}`); 
        }
        console.log(error);
        setMessage('Failed to resend activation link.');
        status.current = 0
      }
    };
    const handleClose = () => {
        navigate("/");
    };
    console.log(message)
    console.log(error)
    console.log(status.current)
    console.log(props.resendLink)
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="modal-content w-full max-w-sm p-6 bg-primary-100 white rounded-lg shadow-lg space-y-4 relative">
                <div className="w-full max-w-sm p-6 rounded-lg shadow-lg space-y-4 bg-tertiary-600 relative">
                    {/* Close button */}
                    <button
                      onClick={handleClose}
                      className="absolute top-2 right-2 w-8 h-8 flex items-center justify-center text-gray-500 hover:text-gray-700 hover:bg-gray-200 rounded-full transition-colors z-10"
                      aria-label="Close"
                    >
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                        <div className="flex justify-center items-center w-full"><Logo/></div>
                        <div className="flex justify-center items-center w-full">
                            {error && <p className="flex text-red-500 text-center">{error}</p>}
                        </div>
                        <div className="flex justify-center items-center w-full">
                            {message && <p className="flex text-red-500 text-center">{message}</p>}
    
                        </div>
                        {status.current === 1 ? (
                            <div className="flex justify-center items-center w-full">
                                <Button data-cy="close" onClick={handleClose} className={`${buttonClass} text-center`} type="button">Close</Button>
                            </div>
                        ): (
                            <form onSubmit={handleSubmit}>
                              <div className="flex flex-col justify-center items-center w-full">
                                  {props.resendLink && <div className="text-red-500 text-center mr-2 ml-2 mb-4">{props.resendLink}</div>}
                                  <input type="email" 
                                  name="email" 
                                  id="email"
                                  value={form.email}
                                  onChange={handleChange}
                                  placeholder="Enter your Email"
                                  className={`${fieldClass}`}
                                  autoComplete="new-password"
                                  required />
                                  <Button data-cy="resendlink" type="submit" className={`${buttonClass} text-center w-full`} >Resend Activation Email</Button>
                                  <Button data-cy="cancel" onClick={handleClose} className={`${buttonClass} text-center w-full`} type="button">Cancel</Button>
                              </div>
                            </form>
                        )}
                        
                        
                </div>
            </div>
        </div>
    )
  };